







import { Component, Vue, Watch } from "vue-property-decorator";

import PageTitle from "@/components/common/PageTitle.vue";
import { complaintsModule } from "@/plugins/store-accessors";
import { DocumentsList } from "./blocks/DocumentsList";

@Component({
  components: {
    DocumentsList,
    PageTitle,
  },
})
export default class ComplaintsPage extends Vue {
  get meta() {
    return complaintsModule.getMeta;
  }

  @Watch("$route")
  async complaints() {
    await complaintsModule.requestComplaints({
      ...this.$route.params,
      query: this.$route.query,
      route: this.$route.name,
    });
  }

  mounted() {
    this.complaints();
  }
}
